export function countPayrollWarnings(warnings = []) {
  return warnings.reduce((acc, warning) => {
    const key = warning.severity || 'warning';
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});
}

export function buildPayrollConfirmMessage(warnings = []) {
  if (!warnings.length) {
    return '급여를 확정하시겠습니까?\n확정 후에는 수정할 수 없습니다.';
  }

  const counts = countPayrollWarnings(warnings);
  const danger = counts.danger || 0;
  const warning = counts.warning || 0;
  const info = counts.info || 0;
  const head = [
    '급여 데이터에 확인할 항목이 있습니다.',
    `위험 ${danger}건 / 주의 ${warning}건 / 근거 ${info}건`,
    '',
  ];
  const preview = warnings.slice(0, 8).map((item, idx) => {
    const date = item.date ? ` ${item.date}` : '';
    const detail = item.detail ? ` (${item.detail})` : '';
    return `${idx + 1}. ${item.user_name || '직원'}${date} - ${item.title}${detail}`;
  });
  const more = warnings.length > preview.length
    ? [`외 ${warnings.length - preview.length}건이 더 있습니다.`]
    : [];

  return [
    ...head,
    ...preview,
    ...more,
    '',
    '그래도 급여를 확정하시겠습니까?',
    '확정 후에는 수정할 수 없습니다.',
  ].join('\n');
}
